/**
 * A key identifying the session a fetched notification count belongs to.
 * @returns a stable string key, or null when nobody is signed in.
 */
export const resolveNotificationIdentity = (auth, userData) => {
  const userId = userData?._id || userData?.userId || auth?._id || auth?.userId || null;

  if (!userId) {
    return null;
  }

  return auth?.token ? `${userId}:${auth.token}` : String(userId);
};
